(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('HubspotDeal', HubspotDeal);

    HubspotDeal.$inject = ['$resource'];

    function HubspotDeal ($resource) {
        var resourceUrl =  'api/hubspot-deals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
